import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, STREAMING, ASSETS } from "../mock";
import { fbTrack } from "../lib/track";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a0410]/90 backdrop-blur-md py-3 border-b border-[#d4af37]/20"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1300px] mx-auto px-6 flex items-center justify-between">
        <a href="#top" onClick={(e) => handleNav(e, "#top")} className="flex items-center gap-3 group">
          <img
            src={ASSETS.logo}
            alt="J. Crown"
            className="h-10 md:h-12 w-auto object-contain rounded transition-transform duration-500 group-hover:scale-105"
          />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              className="text-xs tracking-[0.2em] uppercase text-neutral-200 hover:text-[#e8c65a] transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-0 after:bg-[#d4af37] after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href={STREAMING[0].href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              fbTrack("ViewContent", {
                content_name: "Listen Now (Header)",
                content_category: "Music",
              })
            }
            className="hidden sm:inline-flex items-center px-5 py-2.5 text-xs tracking-[0.2em] uppercase font-semibold text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] rounded-sm hover:from-[#ffe38f] hover:to-[#d4af37] transition-all duration-300 shadow-[0_0_20px_rgba(212,175,55,0.25)]"
          >
            Listen Now
          </a>
          <button
            className="md:hidden text-[#d4af37]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-500 bg-[#0a0410]/95 ${
          open ? "max-h-96 border-t border-[#d4af37]/20" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              className="py-3 text-sm tracking-[0.2em] uppercase text-neutral-200 hover:text-[#e8c65a] transition-colors border-b border-white/5"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
